import Styles from "./blogs.module.css";
export const Blog       = ( props ) => {
    const { id, bloggerName, bloggerImg, blogTitle, blogLink, blogDiscription } = props;
    const { Blog } = Styles;
    return (
        <div className={ Blog } id={ id }>
            <BlogMainHeader 
                bloggerImg  = { bloggerImg  }
                bloggerName = { bloggerName }
                blogLink    = { blogLink    }
            />
            <BlogMainContent 
                title = { blogTitle       }
                text  = { blogDiscription }
            />
        </div>
    );
};
const BlogMainHeader    = ( props ) => {
    const { bloggerImg, bloggerName, blogLink } = props;
    const { BlogMainHeader } = Styles;
    return (
        <header className={ BlogMainHeader }>
            <div>
                <div><img src={ bloggerImg }/></div>
                <span></span>
                <h1><bdi>{ bloggerName }</bdi></h1>
            </div>
            <div>
                <a href={ blogLink }><i className="bi bi-folder-symlink-fill"></i></a>
            </div>
        </header>
    );
};
const BlogMainContent   = ( props ) => {
    const { title, text } = props;
    const { BlogMainContent } = Styles;
    return (
        <div className={ BlogMainContent }>
            <h2><bdi>{ title }</bdi></h2>
            <p ><bdi>{ text  }...</bdi></p >
        </div>
    );
};